export class GDPRContact {
  contactId: number;
  optOutFlag: string;
}
